import React from "react";
import Socialsgrid from "../components/Socialsgrid/Socialsgrid.jsx";
import goldloxeLogo from "../Images/goldloxe_white.png"; // Verify this path
import bgLeft from "../Images/HeroImage.png"; // Verify this path
import bgRight from "../Images/Black_Smiley_Face.jpg"; // Verify this path

import "./FrontPage.css"; // Use .css extension consistently

function FrontPage() {
  return (
    <div className="fp container-fluid p-0 position-relative">
      {/* Background Layer */}
      <div className="fp-background-layer" style={{ backgroundImage: `url(${bgRight})` }}>
        <div 
          className="fp-background-left"
          style={{ backgroundImage: `url(${bgLeft})` }}
        ></div>
      </div>

      {/* Content Layer */}
      <div className="content-layer">
        <div className="logo-container" style={{ backgroundImage: `url(${goldloxeLogo})` }}></div>
        <div className="fp-subtitle sectionText">
          <h2></h2>
          <h3>NYC Street Artist reminding us we are all Cosmic Lottery Winners</h3>
          <Socialsgrid />
        </div>
      </div>
    </div>
  );
}

export default FrontPage;